import axios from "axios";
import { BaseUrl, FacilityBaseUrl } from "../Routes/BaseUrl";

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const getApiBaseByType = (type) =>
  type === "pharmacy" ? FacilityBaseUrl.trim() : BaseUrl.trim();

export const getAllFacilities = async (type, page = 1) => {
  const endpoints = {
    pharmacy: `/facility/getAll/facilityProfile?page=${page}`,
    lab: `/labAuth/getAllApi?page=${page}`,
    hpp: `/hppAuth/getAllApi?page=${page}`,
  };

  const response = await axios.get(`${getApiBaseByType(type)}${endpoints[type]}`, getAuthHeaders());
  return response.data;
};

export const createFacilityInitial = async (type, data) => {
  const endpoints = {
    pharmacy: "/facility/facilityCreate",
    lab: "/labAuth/labAuthCreate",
    hpp: "/hppAuth/hppAuthCreate",
  };

  const response = await axios.post(`${getApiBaseByType(type)}${endpoints[type]}`, data);
  return response.data;
};

export const createFacilityProfile = async (type, data) => {
  const endpoints = {
    pharmacy: "/facility/facilityProfile",
    lab: "/labAuth/labAuthProfile",
    hpp: "/hppAuth/hppAuthProfile",
  };

  const response = await axios.post(`${getApiBaseByType(type)}${endpoints[type]}`, data);
  return response.data;
};

export const updateFacility = async (type, id, data) => {
  const endpoints = {
    pharmacy: `/facility/facilityProfile/update/${id}`,
    lab: `/labAuth/labAuthProfileUpdate/${id}`,
    hpp: `/hppAuth/hppProfileUpdate/${id}`,
  };

  const response = await axios.put(`${getApiBaseByType(type)}${endpoints[type]}`, data, getAuthHeaders());
  return response.data;
};

export const deleteFacility = async (type, id) => {
  const endpoints = {
    pharmacy: `/facility/facilityProfile/delete/${id}`,
    lab: `/labAuth/lapAuthProfileDelete/${id}`,
    hpp: `/hppAuth/deleteProfileUpdate/${id}`,
  };

  const response = await axios.delete(`${getApiBaseByType(type)}${endpoints[type]}`, getAuthHeaders());
  return response.data;
};

export const fetchDashboardCounts = async () => {
  try {
    const url = `${BaseUrl}/admin/dashboard-counts`;
    const response = await axios.get(url, getAuthHeaders());
    
    // Backend sends: { status: 200, message: "...", data: { facilityCount, doctorCount, patientCount } }
    const dashboardData = response.data.data;
    
    return {
      facilityCount: dashboardData.facilityCount || 0,
      doctorCount: dashboardData.doctorCount || 0,
      patientCount: dashboardData.patientCount || 0,
    };
  } catch (error) {
    throw error;
  }
};